import React, { useEffect, useRef, useState } from 'react'
import { Form, Input, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const ContentListSearchBox = ({ onChange, onSubmit, value }) => {
   const searchField = useRef()
   const [activeSearchValue, setActiveSearchValue] = useState(null)

   // Ensure this component is either controlled or uncontrolled
   // We don't allow just 'value' to be set because makes no sense
   // for a search field to be read-only.
   const valueIsSet = typeof value !== 'undefined'
   const onChangeIsSet = typeof onChange !== 'undefined'
   if (valueIsSet !== onChangeIsSet) {
      throw new Error('This component must be controlled or uncontrolled. ' +
         'To make it controlled, pass both `value` and `onChange`')
   }

   const handleChange = (event) => {
      onChange(event.currentTarget.value)
   }

   const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
         event.preventDefault()
         setActiveSearchValue(event.currentTarget.value)
         onSubmit(event.currentTarget.value.trim())
      }
   }

   const handleClear = () => {
      // If controlled, call `onChange`.
      // If uncontrolled, manipulate the DOM element directly.
      if (onChange) {
         onChange('')
      } else {
         searchField.current.value = ''
      }

      onSubmit('')
      setActiveSearchValue(null)
   }

   useEffect(() => {
      if (!value) {
         setActiveSearchValue(null)
      }
   }, [value])

   let controlledInputProps = null
   if (onChange) {
      controlledInputProps = {
         value,
         onChange: handleChange
      }
   }

   return (
      <View float="left" width="100%" backgroundColor="#fff">
         <View
            width="100%"
            borderBottom="1px solid #eee"
            padding="12px">
            <Form
               elementAppearance="plain"
               elementBackgroundColor="#eee"
               elementFocusBackgroundColor="#f3f3f3">
               <Input
                  {...controlledInputProps}
                  ref={searchField}
                  onKeyPress={handleKeyPress}
                  placeholder="Search"
                  size="md"
               />
            </Form>
         </View>
         {activeSearchValue && (
            <View
               width="100%"
               backgroundColor="#fff"
               borderBottom="1px solid #eee"
               padding="12px">
               <Text size="2">
                  Search Results for:
                  &nbsp;
                  <b>{activeSearchValue}</b>
               </Text>
               <View onClick={handleClear} style={{ cursor: 'pointer' }}>
                  <Text size="2" color="#aaa">
                     <u>Clear current search</u>
                  </Text>
               </View>
            </View>
         )}
      </View>
   )
}

ContentListSearchBox.propTypes = {
   onChange: PropTypes.func,
   onSubmit: PropTypes.func.isRequired,
   value: PropTypes.string
}

ContentListSearchBox.defaultProps = {
   onChange: undefined,
   value: undefined
}

export default ContentListSearchBox
